"use client";

import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useContinueAfterManualTprStepMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { StepKey } from "@/src/lib/workflows/steps/types";
import { type Task, TaskStatus } from "@/src/models/task";
export function TprManualStepContinueButton({
  task,
  stepKey
}: {
  task: Task;
  stepKey: StepKey;
}) {
  const recheckEligibility = stepKey === StepKey.SUBMIT_ATHENA_INSURANCE_ELIGIBILITY;
  const continueMutation = useContinueAfterManualTprStepMutation();
  const localTaskUpdateMutation = useLocalTaskUpdateMutation({
    invalidateOnSettled: false
  });
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  const handleContinue = async () => {
    try {
      await continueMutation.mutateAsync({
        taskId: task.id,
        stepKey
      });
      localTaskUpdateMutation.mutate({
        ...task,
        status: TaskStatus.PROCESSING
      });
      refreshTprWorkflowProgress(invalidateInstructions);
      toast({
        title: recheckEligibility ? "Eligibility recheck started" : "Manual step confirmed",
        description: recheckEligibility ? "The workflow will read and save Athena’s eligibility result before continuing." : "The workflow is continuing with the remaining steps."
      });
    } catch (error) {
      toast({
        title: "Unable to continue the workflow",
        description: error instanceof Error ? error.message : "Refresh the task and try again.",
        variant: "destructive"
      });
    }
  };
  return <Button size="sm" onClick={handleContinue} disabled={continueMutation.isPending || localTaskUpdateMutation.isPending}>
      {continueMutation.isPending ? "Continuing..." : recheckEligibility ? "Recheck eligibility" : "Continue"}
    </Button>;
}